import { App } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import type { Callback, MessageProps } from "./useMessage.types"

export const SAVING_CHANGES_PROPS = {
  key: "saving-changes-message",
  loadingKey: "messages.savingChanges",
  successKey: "messages.saved"
}

export const useLoadingMessage = (props: MessageProps, cb: Callback) => {
  const { message } = App.useApp()
  const { t } = useTranslation()

  const fn = async (...args: any[]) => {
    const { key } = props

    try {
      const { loadingKey = "loading", loadingContent = t(loadingKey) } = props

      message.loading({ key, content: loadingContent, duration: 0 })

      await cb(...args)

      const { successKey = "success", successContent = t(successKey) } = props

      message.success({ key, content: successContent })
    } catch (err: any) {
      const detail = err?.data?.detail
      const content =
        typeof detail === "string" ? detail : t("error.serverError")

      message.error({ key, content })
      props.onError?.()
    }
  }

  return fn
}
